import { useMemo } from "react";
import { useStore } from "./useStore";

/** Claves de `globalOptions.appTexts` que consume el front. */
export const AppTextKey = {
  ACCESS_REQUIREMENT_CHECK: "ACCESS_REQUIREMENT_CHECK",
} as const;

/** `appTexts` viaja sin tipar dentro de `globalOptions`: se acepta tanto el mapa
 * `{ CLAVE: texto }` como la lista `[{ key, text }]`. */
export const resolveAppText = (appTexts: any, key: string): string => {
  if (!appTexts) return "";

  if (Array.isArray(appTexts)) {
    const entry = appTexts.find((item: any) => item?.key === key || item?.code === key);
    if (!entry) return "";
    const value = entry.text ?? entry.value ?? entry.description ?? "";
    return typeof value === "string" ? value : "";
  }

  const value = appTexts[key];
  if (typeof value === "string") return value;
  // Algunos textos podrían venir envueltos en un objeto en vez de sueltos.
  if (value && typeof value === "object") {
    const nested = value.text ?? value.value ?? value.description ?? "";
    return typeof nested === "string" ? nested : "";
  }
  return "";
};

/** Texto configurable por edificio, ya traducido por el backend. Devuelve "" si el edificio no lo
 * tiene cargado, así que el llamador decide si muestra el bloque o no. */
const useAppText = (key: string): string => {
  const { authStore } = useStore();

  return useMemo(() => resolveAppText(authStore.appTexts, key), [authStore.appTexts, key]);
};

export default useAppText;
